module.exports = __webpack_public_path__ + "img/人才智库banner.a6549c72.png";